import axios from "axios";

const getPasscodes = () => {
  return axios.get("/api/admin/passcodes");
};

const assignCompanion = (
  passcode,
  assignedPersonaId1,
  assignedPersonaId2 = ""
) => {
  return axios.patch(
    `/api/admin/passcodes/${encodeURIComponent(passcode)}/companion`,
    { assignedPersonaId1, assignedPersonaId2 }
  );
};

const getBaselineBriefing = (passcode) => {
  return axios.get(
    `/api/admin/passcodes/${encodeURIComponent(passcode)}/baseline-briefing`
  );
};

const updateBaselineBriefing = (
  passcode,
  userName,
  baselineBriefing
) => {
  return axios.patch(
    `/api/admin/passcodes/${encodeURIComponent(passcode)}/baseline-briefing`,
    {
      userName,
      baselineBriefing,
    }
  );
};

const updateAnalyticsEnabled = (passcode, analyticsEnabled) => {
  return axios.patch(
    `/api/admin/passcodes/${encodeURIComponent(passcode)}/analytics`,
    { analyticsEnabled }
  );
};

const passcodesApi = {
  getPasscodes,
  assignCompanion,
  getBaselineBriefing,
  updateBaselineBriefing,
  updateAnalyticsEnabled,
};

export default passcodesApi;